export const isPersonalInjuryRole = (role) => String(role || '').trim().toLowerCase() === 'paralegal personal injury';

export const PERSONAL_INJURY_SECTIONS = new Set([
  'casos_accidentes', 'clientes', 'importar_drive', 'usuarios', 'configuracion', 'pausa_activa',
]);

export const mayOpenSection = (role, section) => !isPersonalInjuryRole(role) || PERSONAL_INJURY_SECTIONS.has(section);
